export default (props, vars) => props?.['name'] === 'link';
